<template>
  <div class="exh">
    <h4 class="exh__h">Two decades of near-silence, then six shows at Palazzo Fortuny.</h4>
    <div class="exh__bars">
      <div class="exh__row" v-for="d in decades" :key="d.label">
        <div class="exh__dec">
          <span class="exh__dec-l">{{ d.label }}</span>
          <span class="exh__dec-t">{{ d.solo + d.group }} shows</span>
        </div>
        <div class="exh__track">
          <div class="exh__fill exh__fill--solo" :class="{ accent: d.label === '2010s' }" :style="{ width: `${(d.solo) * 36}px` }">
            <span v-if="d.solo">{{ d.solo }}</span>
          </div>
          <div class="exh__fill exh__fill--group" :style="{ width: `${(d.group) * 36}px` }">
            <span v-if="d.group">{{ d.group }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="exh__legend">
      <span class="exh__tag exh__tag--solo">solo</span>
      <span class="exh__tag exh__tag--group">group / biennial</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { EXHIBITIONS_BY_DECADE } from '../../data/stroobant';
const decades = EXHIBITIONS_BY_DECADE;
</script>

<style scoped>
.exh {
  margin: 1.4rem 0;
  padding: 1.4rem 1.6rem;
  background: rgba(255,255,255,0.55);
  border: 1px solid var(--vein);
  border-radius: 4px;
}
.exh__h {
  font-family: var(--font-body);
  font-size: clamp(1.4rem, 2.4vw, 1.9rem);
  font-weight: 600;
  margin: 0 0 1rem;
  max-width: 30ch;
}
.exh__bars { display: grid; gap: 0.5rem; }
.exh__row {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 1rem;
  align-items: center;
}
.exh__dec-l {
  display: block;
  font-family: var(--font-body);
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--slate);
}
.exh__dec-t {
  display: block;
  font-size: 0.84rem;
  color: var(--granite);
  font-style: italic;
}
.exh__track { height: 32px; display: flex; gap: 2px; }
.exh__fill {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-body);
  font-weight: 600;
  border-radius: 2px;
}
.exh__fill--solo { background: var(--accent-soft); color: var(--slate); }
.exh__fill--solo.accent { background: var(--accent); color: var(--paper); }
.exh__fill--group { background: var(--granite); color: var(--paper); }
.exh__legend { display: flex; gap: 1.2rem; margin-top: 0.8rem; font-size: 0.82rem; color: var(--granite); }
.exh__tag--solo::before { content: ''; display: inline-block; width: 12px; height: 12px; background: var(--accent-soft); margin-right: 0.4rem; border-radius: 2px; vertical-align: middle; }
.exh__tag--group::before { content: ''; display: inline-block; width: 12px; height: 12px; background: var(--granite); margin-right: 0.4rem; border-radius: 2px; vertical-align: middle; }
</style>
